<!--我的跟单-->
<template>
	<div class="page-body center-wrap">
		<div class="follow_title">
			<span class="back" @click="$nav.back()">交易廣場</span>
			<i class="el-icon-arrow-right"></i>
			<span class="user">aiden1 (事件合約跟單)</span>
		</div>
		<div class="user_info_box show">
			<div class="item_top_left">
				<div>
					<img src="https://v3.ptdemot.bio/uploads/f056827af159483b81d948bddd15efab.png" class="avatar-img">
				</div>
				<div class="item_name">
					<div class="item_name_level">
						<span>aiden1</span>
						<span class="user_level">LV.9</span>
					</div>
				</div>
				<div class="line_num">
					<span>+6%</span>
					<span>+$4,045,943.648789</span>
				</div>
				<div class="quota">
					<div class="quota_line">
						<span>名額</span>
						<span class="ma">2,365</span><span>/5,000</span>
					</div>
					<div class="quota_line">
						<span>跟單碼</span>
						<span class="ma">@010</span>
					</div>
				</div>
				<div class="quota">
					<div class="quota_line">
						<span>勝率</span>
						<span class="ma">102.66%</span>
					</div>
					<div class="quota_line">
						<span>帶單規模</span>
						<span class="ma">$14,440,913.43684</span>
					</div>
				</div>
			</div>
			<div class="item_top_right">
				<button class="follow_btn">跟單</button>
				<button class="back_btn" @click="$nav.back()">返回</button>
			</div>
		</div>

		<el-tabs v-model="activeName" @tab-click="handleClick" style="padding: 0 20px;">
			<el-tab-pane label="帶單表現 " name="1"></el-tab-pane>
			<el-tab-pane label="目前帶單 " name="2"></el-tab-pane>
			<el-tab-pane label="歷史帶單 " name="3"></el-tab-pane>
		</el-tabs>

		<mode1 v-if="activeName == 1"></mode1>
		<mode2 v-else></mode2>
	</div>
</template>
<script>
	import mode1 from './components/detailsModel1.vue';
	import mode2 from './components/detailsModel2.vue';
	export default {
		components: {
			mode1,
			mode2,
		},
		data() {
			return {
				activeName: '1',
			};
		},
		mounted() {

		},
		beforeUnmount() {},
		methods: {
			handleClick() {},

		},
	};
</script>
<style lang="scss" scoped>
	.user_info_box {
		border: 1px solid #3c3e53;
		border-radius: 999px;
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 30px;

		.item_top_right {
			button {
				border-width: 0;
				font-size: 14px;
			}

			.follow_btn {
				min-width: 80px;
				height: 40px;
				background: #00f0ff;
				color: #000;
				border-radius: 999px;
				margin-right: 20px;
				cursor: pointer;
			}

			.back_btn {
				min-width: 80px;
				height: 40px;
				color: #000;
				background: #fff;
				border-radius: 999px;
				margin-right: 20px;
				cursor: pointer;
			}
		}

		.item_top_left {
			display: flex;
			align-items: center;

			.quota {
				margin-left: 50px;
				display: flex;
				flex-direction: column;
				justify-content: center;

				.quota_line {
					color: #888;

					span {
						&:first-child {
							width: 80px;
							display: inline-block;
							text-align: right;
							margin-right: 10px;
						}

						&.ma {
							color: #fff;
						}
					}
				}
			}

			.line_num {
				margin-left: 50px;
				display: flex;
				flex-direction: column;

				span {
					&:first-child {
						color: #00f0ff;
						font-size: 24px;
						line-height: 1;
						font-family: Franklin Gothic Medium, Arial Narrow, Arial, sans-serif;
					}
				}
			}

			.item_name {
				margin: 0 10px;

				.item_name_level {
					span {
						&:first-child {
							color: #fff;
							font-size: 18px;
						}
					}

					.user_level {
						display: inline-block;
						padding: 0px 5px;
						font-weight: 600;
						line-height: 23px;
						border-radius: 100px;
						color: #a07300;
						background: linear-gradient(270deg, #fcdf7b, #f9cd4e);
					}
				}
			}

			.avatar-img {
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}
		}
	}

	.follow_title {
		color: #888;
		font-size: 16px;
		display: flex;
		align-items: center;
		gap: 10px;
		margin-top: 10px;

		.user {
			color: #00f0ff;
		}
	}
</style>